'use client'

import useUser from "@/hooks/useUser"
import { ReadonlyUserType, updateUserTypes, userDetailMessagesTypes, WhoamiType } from "@/type/user"
import api from "@/util/api"
import { createContext, ReactNode, useEffect, useState } from "react"

interface AuthContextType {
    user: WhoamiType
    setUser?: any
    login?: any
    logout?: any
    userUpdate: (arg: updateUserTypes)=> void
    loading: boolean
    messages: userDetailMessagesTypes
    setUserPoint: (setPoint: number) => void
    requiredExp: ExpTypes[],
    getUserDetail : ()=>void,
    justLoggedOut : boolean
}
interface ExpTypes {
    level: number
    required_exp: number
}
const messagesDefault = {
        total_count: 0,
        read_count: 0,
        unread_count: 0,
    }
export const AuthContext = createContext<AuthContextType>({
    user: { is_authenticated: false },
    userUpdate: ()=> {},
    loading: true,
    messages: messagesDefault,
    setUserPoint: () => { },
    requiredExp: [],
    getUserDetail:()=>{},
    justLoggedOut:false
})

export default function AuthProvider({ children }: { children: ReactNode }) {
    const { user, 
            setUser, 
            login, 
            logout, 
            loading, 
            justLoggedOut 
          } = useUser()
    const [messages, setMessages] = useState<userDetailMessagesTypes>(messagesDefault)
    const [requiredExp, setRequiredExp] = useState<ExpTypes[]>([])

    function userUpdate(update: updateUserTypes){
        setUser(Object.assign({}, user, update))
    }

    function getUserDetail() {
        api(`/api/user/detail/`)
            .then(res => res.json())
            .then(({ data, status_code }) => {
                if (status_code == 200) {
                    const getData = data.object
                    setMessages(getData.messages)
                }
            })
    }

    function getExp(){        
        api(`/api/exp/table/`)
            .then(res=> res.json())
            .then(({data})=> {
                // console.log("***", data.objects)
                setRequiredExp(data?.objects ?? [])
            })
    }

    function setUserPoint(setPoint: number) {
        if (user.is_authenticated) {
            setUser((prev) => {
                return { ...prev, point: setPoint }
            })
        }
    }

    useEffect(()=> {
        getExp();
        getUserDetail();
    }, [])
    const propsValue = {
        user, 
        setUser, 
        userUpdate,
        login, 
        logout, 
        loading, 
        setUserPoint, 
        messages, 
        requiredExp, 
        getUserDetail,
        justLoggedOut
    }
    return (
        <AuthContext.Provider value={propsValue}>
            {children}
        </AuthContext.Provider>
    )
}